import { Component, Injectable, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ITextValue } from '../../../models/ITextValue';
import { FormGroup, FormControl } from '@angular/forms';
import { IReport, IReportPost } from '../../../models/IReport';
import * as moment from 'moment';
import * as _ from 'lodash';
import { ToasterService } from 'angular2-toaster';
import { HttpService } from '../../../services/HttpService';

@Component({
  selector: 'app-report-form',
  templateUrl: './report-form.component.html',
  styleUrls: ['./report-form.component.scss'],
  providers: [ToasterService],
})

@Injectable()
export class AppReportFormComponent implements OnInit {
  selectedItem: ITextValue;
  modelValue: ITextValue;
  reportForm: FormGroup;

  constructor(private http: HttpService) {
  }

  @Input() showCancel: boolean;
  @Input() report: IReport;
  @Output() saved: EventEmitter<IReportPost> = new EventEmitter();
  @Input() projects: ITextValue[];
  @Input() defaultProject: number;

  submitReportForm(event, form) {
    form.submitted = true;

    if (!form.valid) {
      return;
    }

    const model: IReportPost = {
      id: !this.report ? 0 : this.report.id,
      date: this.truncateTime(form.value.date),
      description: form.value.description,
      hours: +form.value.hours,
      projectId: form.value.projectId
    };

    this.saved.emit(model);
  }

  clearReport(): any {

    setTimeout(() => {
      const reportId = this.report.projectId != null ? this.report.projectId : this.defaultProject;
      this.reportForm = new FormGroup({
        date: new FormControl(new Date()),
        description: new FormControl(''),
        hours: new FormControl(8),
        projectId: new FormControl(reportId)
      });
    })
  }

  cancelForm() {
    this.report.edited = false;
  }

  truncateTime(date: Date): Date {
    return new Date(moment(date).format('YYYY-MM-DD'));
  }


  ngOnInit(): void {
    this.reportForm = new FormGroup({
      date: new FormControl(new Date()),
      description: new FormControl(''),
      hours: new FormControl(8),
      projectId: new FormControl()
    });

    setTimeout(() => {
      if (this.report != null) {
        this.reportForm.setValue({
          date: this.report.date,
          description: this.report.description,
          hours: this.report.hours,
          projectId: this.report.projectId != null ? this.report.projectId : this.defaultProject
        });
      }
    }, 1);
  }
}

